import React from "react";
import "../../assets/styles/components/model.scss";
import Icon from "@mdi/react";
import { mdiCheckCircleOutline  } from "@mdi/js";

interface Props {
  show: boolean;
  title?: string;
}
const SucceedModal: React.FC<Props> = ({ show, title }) => {
  return (
    <div className={`${show ? "modal-open" : "modal-close"}`}>
      <div className="custom custom-check">
        <div className="icon-check">
          <Icon path={mdiCheckCircleOutline } size="80" />
        </div>
        <p>{title}</p>
      </div>
    </div>
  );
};
export default SucceedModal;
